import React from 'react';
import PropTypes from 'prop-types';
import useTimer from '../../hooks/useTimer';

const timeFormatter = (second = 0) => {
  const m = `${parseInt(second / 60, 10)}`.padStart(2, 0);
  const s = `${second % 60}`.padStart(2, 0);
  return `${m}:${s}`;
};

const Timer = ({ initSecond = 240, timeOver, formatter = timeFormatter }) => {
  const remine = useTimer(initSecond);
  if (remine === 0) {
    timeOver();
  }
  return (
    <span>{formatter(remine)}</span>
  );
};

Timer.propTypes = {
  timeOver: PropTypes.func,
  formatter: PropTypes.func,
  initSecond: PropTypes.number,
};

const memoized = React.memo(Timer);

export default memoized;
